import React from 'react';
import { Link } from 'react-router-dom';

const AdminPanel = () => {
  return (
    <div className="page-container">
      <h1>Pannello Amministrazione</h1>

      <div className="admin-cards">
        <Link to="/admin/users" className="admin-card">
          <h2>Gestione Utenti</h2>
          <p>Aggiungi, modifica o elimina utenti della piattaforma</p>
        </Link>

        <Link to="/admin/targets" className="admin-card">
          <h2>Gestione Persone</h2>
          <p>Gestisci la lista delle persone da visitare</p>
        </Link>
      </div>
    </div>
  );
};

export default AdminPanel;
